import { selectCurrentRoles } from 'features/auth/authSlice';
import { useGetLoanProductMasterQuery } from 'features/CrmDashboardComp/CmrApiSlice';
import React,{useState,useEffect} from 'react'
import { Col } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import Select from "react-select";

export const ProductNameFilter = ({bank_name,setBankName,setProductName,productName,customStyles,className}) => {
      const [loanData, setLoanData] = useState([]); 
        const RolesFromToken = useSelector(selectCurrentRoles);
      
      const { data: loanMasterData } = useGetLoanProductMasterQuery({bank_name}, {
        skip: !bank_name 
      });
     const BankNames = [
        { label: "Bandhan Bank", value: "Bandhan Bank" },
        { label: "Bank Of Baroda", value: "Bank Of Baroda" },
        { label: "Punjab and Sind Bank", value: "Punjab and Sind Bank" },
        { label: "State Bank of India", value: "State Bank of India" },
  ];
      const isInitialBank=RolesFromToken?.groups?.includes("Banker") || RolesFromToken?.groups?.includes("Bank_Of_Baroda_Banker")

useEffect(() => {
  if (loanMasterData !== undefined) {
    const responseAgentArray = loanMasterData.data
      .map((item) => ({
        value: item.id,
        label: item.product_name,
        productCode: item.product_code,
        productCategory: item.product_category,
      }))
      .sort((a, b) =>
        a.label.localeCompare(b.label, "en", { sensitivity: "base" })
      );

    setLoanData(responseAgentArray);
  }
}, [loanMasterData]);

  return (
    <>
    {!isInitialBank&&
      <Col sm="2" className={`mb-2 position-relative ${className}`}>
                    <Select
                      menuPlacement="auto"
                      options={BankNames}
                      placeholder="Bank Name"
                      value={BankNames.find((opt) => opt.value === bank_name) || null}
                      onChange={(option) => setBankName(option?.value)}
                      styles={customStyles}
                    />
    
                    {bank_name && (
                      <span
                        className="clear-icon"
                        onClick={() => {
                          setBankName("");
                        }}
                        style={{
                          position: "absolute",
                          top: "60%",
                          right: "60px",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                          color: "gray",
                          fontSize: "12px",
                          zIndex: 1000,
                        }}
                      >
                        ✕
                      </span>
                    )}
                  </Col>
}
                <Col sm="2" className={`mb-2 position-relative ${className}`}>
                    <Select
                      menuPlacement="auto"
                      options={loanData}
                      placeholder="Product Name"
                      value={
                        productName
                          ? { value: productName, label: productName }
                          : null
                      }
                      onChange={(e) => setProductName(e.label)}
                      styles={customStyles}
                    />
                    {productName && (
                      <span
                        className="clear-icon"
                        onClick={() => {
                          setProductName("");
                        }}
                        style={{
                          position: "absolute",
                          top: "60%",
                          right: "60px",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                          color: "gray",
                          fontSize: "12px",
                          zIndex: 1000,
                        }}
                      >
                        ✕
                      </span>
                    )}
                  </Col>
    </>
  )
}
